import { render, staticRenderFns } from "./DTR.vue?vue&type=template&id=55ce606a&scoped=true"
import script from "./DTR.vue?vue&type=script&lang=js"
export * from "./DTR.vue?vue&type=script&lang=js"
import style0 from "./DTR.vue?vue&type=style&index=0&id=55ce606a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ce606a",
  null
  
)

export default component.exports